export const accounts = [
  { 
    accountId: 3448,
    title: "Argent Bank Checking (x3448)",
    amount: "$48,098.43",
    description: "Available Balance",
  },
  {
    accountId: 6712,
    title: "Argent Bank Savings (x6712)",
    amount: "$10,928.42",
    description: "Available Balance",
  },
  {
    accountId: 8343,
    title: "Argent Bank Credit Card (x8343)",
    amount: "$184.30",
    description: "Current Balance",
  },
];
